export default __webpack_public_path__ + "static/media/overview1.6b8bc8c4.jpg";